import React, {useState, Fragment, useEffect} from 'react';
import { Card, CardContent } from '@mui/material';
import AlertaDeRespuesta from 'components/AlertaDeRespuesta';
import DialogoPantallaCompleta from 'components/Dialogo/DialogoPantallaCompleta';
import { TablaPersonalizada } from 'components';
import IndicadorDeCarga from 'components/IndicadorDeCarga';
import { obtenerRegistrosPersonalizado } from 'store/actions/customAction';
import { functions } from 'constantes';
import { useDispatch } from 'react-redux';
import ServiciosDelAPI from 'servicios/ServiciosDelAPI';

const ListadoDeEspaciosAsignados = ({ openFullScreenDialog, handleClose, title}) => {
  const dispatch = useDispatch();
  const [datosDeRespuesta, setDatosDeRespuesta] = useState({ tipoDeAlerta: 'error', mensajeDeAlerta: '', mostrarRespuesta: false, });
  const[cargandoSolicitud, setcargandoSolicitud] = useState(false);
  const[listadoDeLosEspaciosAsignados, setListadoDeLosEspaciosAsignados] = useState([]);
  const [encabezadoTabla] = useState([
    { title: 'Nit', field: 'medioDeComunicacion.nit_empresa', cellStyle:{ maxWidth: '80px' }},
    { title: 'Medio', field: 'medioDeComunicacion.tipoDeMedioDeComunicacion.descripcion', cellStyle:{ maxWidth: '80px' }},
    { title: 'Cobertura', field: 'nivelDeCobertura.descripcion', cellStyle:{ maxWidth: '80px' }},
    { title: 'Nombre', field: 'medioDeComunicacion.nombre', cellStyle:{ maxWidth: '80px' }},
    { title: 'Elección', field: 'tipoDeEleccion.eleccion', cellStyle:{ maxWidth: '80px' }},
    { title: 'Cantidad asignada', field: 'cantidadAsignada'},
    { title: 'Tarifa electoral', field: 'tarifaElectoral.tarifa_electoral'},
    { title: 'Fecha asignacion', field: 'fechaDeAsignacion', render: (rowData) => functions.FormatearFecha(rowData?.fechaDeAsignacion || "")},
  ]);

  useEffect( () => {
    obtenerEspaciosAsignados()
  }, [])

  const obtenerEspaciosAsignados = async () => {

    setcargandoSolicitud(true);
    ServiciosDelAPI["gestionarDeEspaciosDeMedios"].metodoDeOrden.clear();
    // ServiciosDelAPI["gestionarDeEspaciosDeMedios"].metodoDeOrden.addAsc("medioDeComunicacion.tipoDeMedioDeComunicacion.id");
    ServiciosDelAPI["gestionarDeEspaciosDeMedios"].metodoDeOrden.addAsc("fechaDeAsignacion");

    let respuesta = await dispatch(obtenerRegistrosPersonalizado({
        controller: "gestionarDeEspaciosDeMedios",
        saveInStore: false,
        nombreDelMetodo: `listar` ,
    }));

    setcargandoSolicitud(false);

    if(respuesta?.error) return setDatosDeRespuesta({ tipoDeAlerta: 'error', mensajeDeAlerta: respuesta?.error?.message || "Inconvenientes al obtener la información", mostrarRespuesta: true, });

    if(respuesta?.data?.length === 0) return setDatosDeRespuesta({ tipoDeAlerta: 'error', mensajeDeAlerta: "No se encontraron datos de espacios asignados", mostrarRespuesta: true, });

    setListadoDeLosEspaciosAsignados(respuesta?.data);
  }

  const handClose = (_, reason) => {
      if (reason === 'clickaway') {return}
      setDatosDeRespuesta({ tipoDeAlerta: 'error', mensajeDeAlerta: "", mostrarRespuesta: false, });
  };

  const { tipoDeAlerta, mensajeDeAlerta, mostrarRespuesta} = datosDeRespuesta;

    return (
      <DialogoPantallaCompleta
        openFullScreenDialog={openFullScreenDialog}
        handleClose={handleClose}
        title={title}
        fullscreen={true}
      >
        <Fragment>
            {cargandoSolicitud ? <IndicadorDeCarga open={cargandoSolicitud} /> : '' }
            <AlertaDeRespuesta type={tipoDeAlerta} content={mensajeDeAlerta} open={mostrarRespuesta} handClose={handClose}/>
            <Card>
                <CardContent>
                  <TablaPersonalizada
                      pageSize={30}
                      data={listadoDeLosEspaciosAsignados}
                      title={"Listado"}
                      header={encabezadoTabla}
                      refreshList={undefined}
                      addRegister={undefined}
                  />
                </CardContent>
            </Card>
        </Fragment>
      </DialogoPantallaCompleta>
    );
}

export default ListadoDeEspaciosAsignados;